module.exports = __webpack_public_path__ + "static/img/Zurqui.dc66c50f.png";